import { render, staticRenderFns } from "./DocumentationServices.vue?vue&type=template&id=3c216b6e"
import script from "./DocumentationServices.vue?vue&type=script&lang=js"
export * from "./DocumentationServices.vue?vue&type=script&lang=js"
import style0 from "./DocumentationServices.vue?vue&type=style&index=0&id=3c216b6e&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c216b6e')) {
      api.createRecord('3c216b6e', component.options)
    } else {
      api.reload('3c216b6e', component.options)
    }
    module.hot.accept("./DocumentationServices.vue?vue&type=template&id=3c216b6e", function () {
      api.rerender('3c216b6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DocumentationServices.vue"
export default component.exports